module.exports = __webpack_public_path__ + "static/media/details-pane-blue-icon.64e3a549.svg";